module.exports = __webpack_public_path__ + "static/media/maf-08.90aa3e08.png";